import { api } from "./api";

export interface AuditLog {
  id: string;
  id_militar: string | null;
  metodo: string;
  rota: string;
  ip: string;
  status_code: number | null;
  user_agent: string | null;
  categoria: string | null;
  descricao: string | null;
  id_alvo: string | null;
  criado_em: string;
}

export interface ListAuditLogsFilter {
  id_militar?: string;
  id_alvo?: string;
  categoria?: string;
  metodo?: string;
  data_inicio?: string;
  data_fim?: string;
  descricao?: string;
  ip?: string;
  page?: number;
  limit?: number;
}

export interface ListAuditLogsResponse {
  logs: AuditLog[];
  total: number;
}

export const auditLogService = {
  async listar(filters: ListAuditLogsFilter = {}): Promise<ListAuditLogsResponse> {
    const params = new URLSearchParams();
    if (filters.id_militar) params.set("id_militar", filters.id_militar);
    if (filters.id_alvo) params.set("id_alvo", filters.id_alvo);
    if (filters.categoria) params.set("categoria", filters.categoria);
    if (filters.metodo) params.set("metodo", filters.metodo);
    if (filters.data_inicio) params.set("data_inicio", filters.data_inicio);
    if (filters.data_fim) params.set("data_fim", filters.data_fim);
    if (filters.descricao) params.set("descricao", filters.descricao);
    if (filters.ip) params.set("ip", filters.ip);
    if (filters.page) params.set("page", String(filters.page));
    if (filters.limit) params.set("limit", String(filters.limit));

    const response = await api.get<ListAuditLogsResponse>(`/audit-logs?${params.toString()}`);
    return response.data;
  },
};
